import { render } from "./reject-btn.vue?vue&type=template&id=046d963b&scoped=true"
import script from "./reject-btn.vue?vue&type=script&lang=js"
export * from "./reject-btn.vue?vue&type=script&lang=js"

import "./reject-btn.vue?vue&type=style&index=0&id=046d963b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046d963b"]])

export default __exports__